import React from "react";
import "./PreFooter.scss";

const PreFooter = () => {
  return (
    <div className="PreFooter">
      <div className="PreFooter-container">
        <img
          className="PreFooter-container_img"
          src="preFooter/preFooter.jpeg"
        ></img>
      </div>
    </div>
  );
};

export default PreFooter;
